import { useId, useRef } from "react";
import type { ReactNode } from "react";
import { useDialogBehavior } from "./useDialogBehavior.js";
import "./Modal.css";

export interface ModalProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
}

export function Modal({ open, onClose, title, children }: ModalProps) {
  const containerRef = useRef<HTMLDivElement | null>(null);
  const generatedId = useId();
  const titleId = title ? `${generatedId}-title` : undefined;

  useDialogBehavior(open, onClose, containerRef);

  if (!open) return null;

  return (
    <div
      className="ui-modal-backdrop"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div
        ref={containerRef}
        className="ui-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        tabIndex={-1}
      >
        {title && (
          <h2 className="ui-modal__title" id={titleId}>
            {title}
          </h2>
        )}
        <div className="ui-modal__content">{children}</div>
      </div>
    </div>
  );
}
